"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Base_1 = __importDefault(require("./Base"));
var firebase_1 = require("./firebase");
var Analysis = /** @class */ (function (_super) {
    __extends(Analysis, _super);
    function Analysis(orgId, analysisId) {
        var _this = _super.call(this, analysisId) || this;
        _this.getOrgId = function () { return _this.orgId; };
        _this.getIdsForUser = function (uid) {
            return _this.getByPath("/users_mapping/" + _this.orgId + "/analysis/" + uid);
        };
        _this.getConfig = function () {
            return _this.getByPath("/analyses_config/" + _this.orgId + "/" + _this.id);
        };
        _this.createQuery = function (queryObject) {
            return _this.create("/queries_config/" + _this.orgId + "/" + _this.id, queryObject);
        };
        _this.getQueries = function () {
            return _this.getByPath("/queries_config/" + _this.orgId + "/" + _this.id);
        };
        _this.getQueryTabs = function (userId) {
            return _this.getByPath("/queries_tabs/" + _this.orgId + "/" + _this.id + "/" + userId);
        };
        _this.updateQueryTabs = function (userId, tabs) {
            return _this.set("/queries_tabs/" + _this.orgId + "/" + _this.id + "/" + userId, tabs);
        };
        _this.getQuery = function (queryId) {
            return _this.getByPath("/queries/" + queryId + "/response");
        };
        _this.getMessages = function () {
            return _this.getByPath("/analyses_messages/" + _this.orgId + "/" + _this.id);
        };
        _this.createMessage = function (messageObject) {
            return _this.create("/analyses_messages/" + _this.orgId + "/" + _this.id, messageObject);
        };
        _this.createTwilioToken = function (twilioTokenRequest) {
            return _this.create("/twilio_tokens/" + _this.orgId + "/" + _this.id, twilioTokenRequest);
        };
        _this.getTwilioToken = function (newToken) {
            return _this.getByPath("/twilio_tokens/" + _this.orgId + "/" + _this.id + "/" + newToken);
        };
        _this.orgId = orgId;
        return _this;
    }
    Analysis.prototype.deleteResource = function (authUserId, resourceId) {
        var request = {
            audit: {
                createdBy: authUserId
            },
            analysisId: resourceId
        };
        return this.create("/apis/" + this.orgId + "/" + authUserId + "/delete_analysis", request);
    };
    ;
    Analysis.prototype.updateName = function (resourceId, config) {
        config.audit.updatedAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
        return this.update("/analyses_config/" + this.orgId + "/" + resourceId, config);
    };
    return Analysis;
}(Base_1.default));
exports.default = Analysis;
//# sourceMappingURL=Analysis.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/data/Analysis.js
// module id = 385
// module chunks = 8